export default "__VITE_ASSET__BHO1ckD3__"